
















import API from '@core/services/API'
import { IDateService } from '@master/services/IDateService'
import { inject } from 'inversify-props'
import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppDialog from '@core/components/AppDialog.vue'
import AppForm from '@core/components/AppForm.vue'
import { ClientPolicyDto } from '../../api'
import { PolicyIndividualDTO } from '@core/pages/CommissionModule/api'

@Component({
  components: {
    AppDatatable,
    AppDialog,
    AppForm
  }
})
export default class SubmittedDocuments extends Vue {
  @Prop() policy: ClientPolicyDto
  @Prop() mainOwner: PolicyIndividualDTO

  @inject()
  private $api: API

  @inject()
  private dateService: IDateService

  private tagableKycPdf: Array<{ value: string; label: string }> = []

  get policyOid () {
    return this.$route.query.policy_oid
  }

  get isDisabled () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  async fetchTagableKycPdf () {
    const { nric } = this.mainOwner?.clientDataSnapshot
    if (!this.mainOwner?.clientDataSnapshot.nric) {
      return
    }

    const headers = [
      '_oid',
      'supervisor_fullname',
      'date_ops_decide',
      'rcmd'
    ]

    const res: { data: Array<any[]> } = await this.$api.kycPdf.list({
      query: '(ma_nric = ? OR ja_nric = ?) AND pdf_status = ?',
      queryArgs: JSON.stringify([nric, nric, 'submission-accepted']),
      headers: JSON.stringify(headers)
    })

    res.data.forEach(row => {
      const kycPdfOid = row[0]
      const plans: Set<string> = new Set()

      row[3].forEach(rcmd => {
        plans.add(rcmd.plan_name)
        rcmd.riders.forEach(rider => {
          plans.add(rider.plan_name)
        })
      })

      const planExistInThisKycPdf = [...plans].filter(plan => this.planNameComparator(this.policy.name, plan)).length > 0

      if (planExistInThisKycPdf) {
        const approvedDateFormatted = this.dateService.format(row[2], 'YYYY-MM-DD, HH:mm')
        const label = `Supervisor: ${row[1]}, Approved Date: ${approvedDateFormatted}`

        this.tagableKycPdf.push({
          value: kycPdfOid,
          label
        })
      }
    })
  }

  planNameComparator (planName1: string, planName2: string): boolean {
    const parsedStr1 = planName1 ? planName1.replace(/&amp;/g, '&').replace(/amp;/g, '') : planName1
    const parsedStr2 = planName2 ? planName2.replace(/&amp;/g, '&').replace(/amp;/g, '') : planName2
    return parsedStr1 === parsedStr2
  }

  async mounted () {
    await this.fetchTagableKycPdf()
  }
}
